import { useUBL } from '@common/log-manager';

export const useShortClipUBL = () => {
  const sendUBL = useUBL();

  const shortClipImpressionUBL = (videoId: string, original_product_id: string, index: number) => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_id: videoId,
      object_idx: index,
      object_section: 'shortform',
      object_type: 'media',
      data: { original_product_id, view_type: 'video' },
    });
  };

  const shortClipClickUBL = (videoId: string, original_product_id: string, index: number) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_id: videoId,
      object_idx: index,
      object_section: 'shortform',
      object_type: 'media',
      data: { original_product_id, view_type: 'video' },
    });
  };
  return {
    shortClipImpressionUBL,
    shortClipClickUBL,
  };
};
